const ADMIN_EMAILS = [
    'kristijan.newdev@gmail.com',
    'savo.m.pvl@gmail.com',
];

export function isAdmin(email: string | null | undefined): boolean {
    if (!email) return false;
    return ADMIN_EMAILS.includes(email);
}
